// extracted by mini-css-extract-plugin
export default {"root":"myota-header_root__ur5r2"};